"use client";
import { Icon } from "@/components/icon";
import classNames from "classnames";
import { ChangeEventHandler, useEffect, useState } from "react";
import { FormItem } from "../form-item";
import { IFileInput } from "./file-input.types";

export const FileInput: IFileInput = ({
  label,
  required,
  className,
  error,
  onChange,
  isInputNeededClear,
  setIsInputNeededClear,
  ...rest
}) => {
  const [selected, setSelected] = useState(false);
  const [selectedFileString, setSelectedFileString] = useState('');

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const value = e.target.value as unknown;
    setSelectedFileString(e.target.files?.[0]?.name ?? '');
    setSelected(!!value);
    onChange && onChange(e);
  };

  useEffect(() => {
    if (isInputNeededClear) {
      setSelected(false);
      setSelectedFileString('');
      setIsInputNeededClear && setIsInputNeededClear(false);
    }
  }, [isInputNeededClear]);

  return (
    <FormItem
      label={label}
      required={required}
      className={classNames(className, "cursor-pointer")}
      error={error}
      focused={selected}
    >
      <input
        {...rest}
        type="file"
        placeholder=""
        onChange={handleChange}
        className={classNames(
          "w-full border-0 absolute top-[0px] z-1 left-0 outline-0 text-[0px] font-[800] pr-[40px] h-full cursor-pointer",
          {
            "opacity-0": !selected,
            "opacity-100": selected,
          }
        )}
      />
      <span className="file-input-value w-full border-0 absolute pt-[26px] px-[20px] top-[0px] left-0 outline-0 text-[18px] font-[800] pr-[40px] h-full cursor-pointer">{selectedFileString}</span>
      <Icon
        name="fileInput"
        className={classNames(
          "absolute right-[20px] top-[20px] duration-200 ease-in text-white"
        )}
      />
    </FormItem>
  );
};
